export const cart = ({number}) => {

    return{
        type: "CART-ITEMS-NUMBER",
        number : number
    }
}